var GOOGLE_LOGO_URL = 'https://www.paypalobjects.com/images/checkout/hermes/powered_by_google_on_white.png';
var GOOGLE_POWERED_BY_LOGO = 'https://www.paypalobjects.com/images/checkout/hermes/PoweredByGoogleLogo130x16.svg';
var ARROW_UP_DOWN_KEY_CODE = ['ArrowUp', 'ArrowDown'];
var NAVIGATION_KEY_CODES = [...ARROW_UP_DOWN_KEY_CODE, 'Tab'];
var LEGACY_KEYCODE_MAPPING = {
  38: 'ArrowUp',
  40: 'ArrowDown',
  9: 'Tab'
};
var CHAR_COUNT_TO_HIDE_INFO_TEXT = 6;
export { ARROW_UP_DOWN_KEY_CODE, CHAR_COUNT_TO_HIDE_INFO_TEXT, GOOGLE_LOGO_URL, GOOGLE_POWERED_BY_LOGO, LEGACY_KEYCODE_MAPPING, NAVIGATION_KEY_CODES };